import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import AppRoot from '../home/HomePage';
import * as homeActions from '../../common/redux/home/actions';
// import * as userActions from '../../common/redux/user/actions';

function mapStateToProps(state) {
  return {
    ...state,
  };
}

// we can merge multiple actions
const actions = [
  homeActions,
  // userActions,
];

function mapDispatchToProps(dispatch) {
  const getActionFunctions = (act) => {
    let resultObj = {};
    act.map((action) => {
      for (const key in action) {
        if (typeof action[key] === 'function') {
          resultObj = Object.assign({}, resultObj, { [key]: action[key] });
        }
      }
      return action;
    });

    return resultObj;
  };

  const creators = getActionFunctions(actions);

  return {
    actions: bindActionCreators(creators, dispatch),
    dispatch,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppRoot));
